import React, { useState } from 'react'
import '../sugarDaddyModal/SugarDaddyModal.css'
import SugarDassyFollowingTabsModal from './SugarDassyFollowingTabsModal';
import SugarDassyFollowersTabsModal from './SugarDassyFollowersTabsModal';
import SugarDassySubscriptionsTabsModal from './SugarDassySubscriptionsTabsModal';
import SugarDassyRequestsTabsModal from './SugarDassyRequestsTabsModal';

const SugarDaddyModal = () => {
      const [activeTab, setActiveTab] = useState(0); // Tracks the active tab
  return (
    <div className='modal-box-sec sugarDaddy-modal-sec'>
        <div className="modal fade" id="sugarDaddyBackdrop1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div class="modal-body">
                        <div className="tabs-container">
                            <div className="tabs-header d-flex flex-wrap justify-content-center align-items-center gap-md-2 gap-1">
                                <button  className={`tab-button d-flex align-items-center justify-content-center ${activeTab === 0 ? "active" : ""}`} onClick={() =>  setActiveTab(0)}>
                                <span className='text-btn'>Following</span>
                                </button>
                                <button   className={`tab-button  d-flex align-items-center justify-content-center ${activeTab === 1 ? "active" : ""}`} onClick={() =>  setActiveTab(1)}>
                                <span className='text-btn'>Followers</span>
                                </button>
                                <button   className={`tab-button  d-flex align-items-center justify-content-center ${activeTab === 2 ? "active" : ""}`} onClick={() =>  setActiveTab(2)}>
                                <span className='text-btn'>Subscriptions</span>
                                </button>
                                <button   className={`tab-button  d-flex align-items-center justify-content-center ${activeTab === 3 ? "active" : ""}`} onClick={() =>  setActiveTab(3)}>
                                <span className='text-btn'>Requests</span>
                                </button>
                            </div>

                            {/* Tab Content */}
                            <div className="tabs-content">
                            {activeTab === 0 && (
                                <div className="tab-panel">
                                    <SugarDassyFollowingTabsModal />
                                </div>
                            )}
                            {activeTab === 1 && (
                                <div className="tab-panel">
                                    <SugarDassyFollowersTabsModal />
                                </div>
                            )}
                            {activeTab === 2 && (
                                <div className="tab-panel">
                                     <SugarDassySubscriptionsTabsModal />
                                </div>
                            )}
                            {activeTab === 3 && (
                                <div className="tab-panel">
                                   <SugarDassyRequestsTabsModal />
                                </div>
                            )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default SugarDaddyModal
